import type { HTMLAttributes, ReactNode } from 'react';

import { cx } from './cx';

export function Card({
  className,
  pad = 'md',
  ...rest
}: HTMLAttributes<HTMLElement> & { pad?: 'none' | 'sm' | 'md' | 'lg' }) {
  const p = { none: '', sm: 'p-5', md: 'p-[22px]', lg: 'p-6' }[pad];
  return (
    <section className={cx('rounded-xl border border-line bg-surface', p, className)} {...rest} />
  );
}

export function CardTitle({
  children,
  className,
  as: As = 'h2',
}: {
  children: ReactNode;
  className?: string;
  as?: 'h2' | 'h3';
}) {
  return (
    <As className={cx('m-0 font-heading text-[17px] font-semibold', className)}>{children}</As>
  );
}

/** Zaglavlje tabele (grid) u stilu dizajna. */
export function TableHead({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      role="row"
      style={style}
      className={cx(
        'grid border-b border-line bg-bg2 text-xs font-semibold tracking-[.02em] text-muted',
        className,
      )}
    >
      {children}
    </div>
  );
}
